import { createFileRoute } from "@tanstack/react-router";
import { buildHead } from "@/lib/seo-head";
import Sobre from "@/pages/Sobre";

export const Route = createFileRoute("/sobre")({
  head: () => buildHead({
    title: "Sobre a OP2P | CRM e Agentes de IA: 20+ anos em comunicação inteligente",
    description: "Conheça a OP2P CRM e Agentes de IA: mais de 20 anos de experiência em comunicação inteligente e um sistema multiagentes de IA com CRM próprio para o comercial, suporte e administrativo.",
    path: "/sobre",
  }),
  component: Sobre,
});
